import React from "react";
import { CLIENT_CONFIG } from "./config";

const lazyNamed = <TModule extends Record<string, unknown>, TName extends keyof TModule>(
  loader: () => Promise<TModule>,
  name: TName
) => React.lazy(async () => {
  const module = await loader();
  return { default: module[name] as React.ComponentType };
});

const AdminHomePage = lazyNamed(() => import("../../components/administratorsView/homepage"), "AdminHomePage");
const HomePage = lazyNamed(() => import("./HomePage"), "HomePage");
const AlarmPage = lazyNamed(() => import("./AlarmPage"), "AlarmPage");
const ManagerAppIndexRedirect = lazyNamed(() => import("./ManagerWebapp"), "ManagerAppIndexRedirect");
const ManagerAuthPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerAuthPage");
const ManagerCreateRequestPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerCreateRequestPage");
const ManagerDevtestPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerDevtestPage");
const ManagerHomePage = lazyNamed(() => import("./ManagerWebapp"), "ManagerHomePage");
const ManagerTechRequestsPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerTechRequestsPage");
const ManagerTechRequestPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerTechRequestPage");
const ManagerTechRequestCreatePage = lazyNamed(() => import("./ManagerWebapp"), "ManagerTechRequestCreatePage");
const ManagerRequestPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerRequestPage");
const ManagerInstructionsPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerInstructionsPage");
const ManagerProfilePage = lazyNamed(() => import("./ManagerWebapp"), "ManagerProfilePage");
const ManagerStatisticsPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerStatisticsPage");
const ManagerTechRequestAnalyticsPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerTechRequestAnalyticsPage");
const ManagerWashingAnalyticsPage = lazyNamed(() => import("./ManagerWebapp"), "ManagerWashingAnalyticsPage");
const ManagerRootRedirect = lazyNamed(() => import("./ManagerWebapp"), "ManagerRootRedirect");
const ManagerWebappLayout = lazyNamed(() => import("./ManagerWebapp"), "ManagerWebappLayout");
const RedirectAuthenticatedManager = lazyNamed(() => import("./ManagerWebapp"), "RedirectAuthenticatedManager");
const RequireManagerAuth = lazyNamed(() => import("./ManagerWebapp"), "RequireManagerAuth");

const routeHeadUrl = CLIENT_CONFIG.ROUTE_HEAD;

export const routes = [
  {
    path: "/",
    Component: ManagerRootRedirect,
  },
  {
    path: "/dealer/:dealerId",
    Component: HomePage,
  },
  {
    path: "/dealer/:id/alarm",
    Component: AlarmPage,
  },
  {
    path: "/dealer/:id/alarm/:type",
    Component: AlarmPage,
  },
  {
    path: "/crm/:freshCrmDealerId",
    Component: HomePage,
  },
  {
    path: "/dealer/:dealerId/adminview",
    Component: AdminHomePage,
  },
  {
    path: "/dealer/app",
    Component: RedirectAuthenticatedManager,
    children: [
      {
        path: "auth",
        Component: ManagerAuthPage,
      },
      {
        index: true,
        Component: ManagerAppIndexRedirect,
      },
    ],
  },
  {
    path: "/dealer/devtest",
    Component: ManagerDevtestPage,
  },
  {
    path: "/dealer/app",
    Component: RequireManagerAuth,
    children: [
      {
        Component: ManagerWebappLayout,
        children: [
          {
            path: "home",
            Component: ManagerHomePage,
          },
          {
            path: "create",
            Component: ManagerCreateRequestPage,
          },
          {
            path: "profile",
            Component: ManagerProfilePage,
          },
          {
            path: "instructions",
            Component: ManagerInstructionsPage,
          },
          {
            path: "instructions/:role",
            Component: ManagerInstructionsPage,
          },
          {
            path: "statistics",
            Component: ManagerStatisticsPage,
          },
          {
            path: "washingAnalytics",
            Component: ManagerWashingAnalyticsPage,
          },
          {
            path: "techRequestsAnalytics",
            Component: ManagerTechRequestAnalyticsPage,
          },
          {
            path: "request/:id",
            Component: ManagerRequestPage,
          },
          {
            path: "techRequests",
            Component: ManagerTechRequestsPage,
          },
          {
            path: "techRequest/:id",
            Component: ManagerTechRequestPage,
          },
          {
            path: "techRequests/create",
            Component: ManagerTechRequestCreatePage,
          },
          {
            index: true,
            Component: ManagerHomePage,
          },
        ],
      },
    ],
  },
];

export const QUEUE_ROUTES = [
    {
      path: "/",
      Component: ManagerRootRedirect,
    },
    ...routes.map((route) => ({
      ...route,
      path: `${routeHeadUrl}${route.path}`,
    }))
];
